import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/homepage/hero";
import About from "../components/homepage/about";
import Services from "../components/homepage/services";
import Testimonials from "../components/universal/testimonials";
import TeamHero from "../components/homepage/teamHero";
import PaymentPlan from "../components/homepage/paymentPlans";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import LeadGenerationModal from "../components/universal/contact-modal";
import Question from "../components/universal/Question";
const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "http://regent-dental.co.uk/#localbusiness",
  name: "Regent Dental",
  image:
    "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
  url: "http://regent-dental.co.uk/",
  telephone: "+01943 661331",
  address: {
    "@type": "PostalAddress",
    streetAddress: "2A Regent Rd",
    addressLocality: "Ilkley",
    addressRegion: "England",
    postalCode: "LS29 9EA",
    addressCountry: "UK",
  },
  openingHours: "Mo-Fr 09:00-17:00",
  priceRange: "$$",
  keywords: [
    "regent dental practice",
    "regent dental",
    "Dental Care",
    "Private dentist",
    "Teeth Whitening treatment",
    "professional teeth dental",
    "Invisalign Braces",
    "dental implants",
    "Composite bonding",
  ],
  sameAs: [
    "https://www.facebook.com/people/Regent-Dental/61564954080373/",
    "https://www.instagram.com/regentdental_ilkley/",
    "https://g.co/kgs/EY9shTo",
  ],
};

const schemaData2 = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "http://regent-dental.co.uk/#website",
  url: "http://regent-dental.co.uk/",
  name: "Regent Dental",
  publisher: {
    "@id": "http://regent-dental.co.uk/#localbusiness",
  },
  potentialAction: {
    "@type": "SearchAction",
    target: "http://regent-dental.co.uk/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const schemaData3 = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "General Dentistry",
  provider: {
    "@id": "http://regent-dental.co.uk/#localbusiness",
  },
  areaServed: {
    "@type": "Place",
    name: "Ilkley, England",
  },
  description:
    "At Regent Dental, we provide a full spectrum of general dentistry services designed to keep your teeth healthy and your smile bright. From routine check-ups to fillings and family dentistry, every aspect of your oral health is covered.",
};
const schemaData4 = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "I am eligible for NHS dental care​?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Regent Dental is a fully private practice and doesn’t have any NHS provision.",
      },
    },
    {
      "@type": "Question",
      name: "What services do you offer?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We offer a full range of general dentistry for the whole family. This includes check-ups to any restorative work that may be needed to get your oral health on track. In addition to this we offer a full range of cosmetic treatments including teeth whitening, Invisalign clear aligners for teeth straightening and dental implants.",
      },
    },
    {
      "@type": "Question",
      name: "How much does an examination cost?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Our new patient examinations are £89 and routine examinations are £55.",
      },
    },
    {
      "@type": "Question",
      name: "How many appointments will I need?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Your check up is completed in a single appointment. If you need any treatment then the type of treatment would determine how many additional appointments are needed.",
      },
    },
    {
      "@type": "Question",
      name: "Do you offer dental plans or memberships?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes - we work with Denplan to offer a range of dental plans which allow you to spread the costs of your dental check ups and hygiene visits over the year.",
      },
    },
    {
      "@type": "Question",
      name: "Where is your dental clinic located?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We’re located just off The Grove on Regent Road and were previously known as Regent Orthodontics.",
      },
    },
    {
      "@type": "Question",
      name: "Do you treat children and families?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes we are proud to offer a full range of treatments for children of all ages and families are more than welcome.",
      },
    },
    {
      "@type": "Question",
      name: "Do you offer weekend or evening appointments?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes we are able to offer weekend and evening appointments on request.",
      },
    },
  ],
};

function Index() {
  return (
    <div>
      <Helmet>
        <title>
          Private Dentist in Ilkley, West Yorkshire | Regent Dental{" "}
        </title>
        <meta
          name="description"
          content="Experience top-quality dental care at Regent Dental in West Yorkshire, offering everything from general dentistry to advanced cosmetic treatments for every smile.​"
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData3)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData4)}
        </script>
        <link rel="icon" href="/favicon.png" />
        <link rel="canonical" href="https://www.regent-dental.co.uk" />
      </Helmet>
      <LeadGenerationModal />
      <Navbar />
      <Header />
      <About />
      <Services />
      <Testimonials />
      <TeamHero />
      <PaymentPlan />
      <Question />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
